module.exports = __webpack_public_path__ + "img/64e24.c4bd569c.svg";